/**
 * Created by nijin on 20/6/17.
 */
import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpService} from "../auth/http.client.service";
import {AuthService} from "../auth/auth.service";
import {Observable} from "rxjs";
import {NotificationType} from "../core/notify/index";
import {NotificationBarService} from "../core/notify/notification.service";

@Injectable()
export class ApiKeyService {

  private accountURI = `${environment.serviceBase}/accounts/:accountId`;

    constructor(private http: HttpService,
                private authService: AuthService,
                private notifier: NotificationBarService) { }

  getApiKeys(){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.get(`${uri}/api-key`)
      .map(response =>  response.json().data)
      .catch(this.handleError)
  }


  generateApiKey(data){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.post(`${uri}/api-key`,data)
      .map(response =>  response.json())
      .catch(this.handleError)
  }

  reGenerateApiKey(id, data){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.post(`${uri}/api-key/${id}/renew`,data)
      .map(response =>  response.json())
      .catch(this.handleError)
  }

  updateWhiteListedIp(id, data){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.put(`${uri}/api-key/${id}`,data)
      .map(response =>  response.json())
      .catch(this.handleError)
  }

  deleteAllApiKeys(){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.delete(`${uri}/api-key`)
      .map(response => response.json())
      .catch(this.handleError)
  }

  deleteKey(id){
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.delete(`${uri}/api-key/${id}`)
      .map(response => response.json())
      .catch(this.handleError)
  }

  private handleError  = (error: Response | any) => {
    let errMsg: string;
    if (error._body) {
      const body = error.json() || '';
      errMsg = body['status'] && body['status'].message ? body['status'].message:'';
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    //this.notifier.create({message: errMsg, type:NotificationType.Error})
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/accounts/api-key.service.ts